import { createContext, useContext, type JSX } from 'react';
import { mentionHorsIa } from './ouvertures-ia.js';

/**
 * LES FAMILLES QUE LES APPS OUVRENT A LIA ET A FLUX, posees par `TakiShell` a
 * partir du registre de l'hote (`famillesOuvertesDesFiches`). Un contexte et pas
 * une prop : la mention se pose en quatre endroits des deux Studios (carte et
 * editeur de porte, lignes du Builder), et le registre complet n'arrive a aucun
 * d'eux par leurs props (le Studio de l'instance ne recoit que les apps
 * installees). Sans fournisseur, `null` : la mention se tait.
 */
export const OuverturesIaContext = createContext<ReadonlySet<string> | null>(null);

/**
 * LA MENTION, a cote du nom de la porte : un libelle discret, la raison au
 * survol. Ce n'est pas un controle, donc le `title` sur un `span` va (G16).
 */
export function MentionHorsIa({
  famille,
  className,
}: {
  famille: string | null | undefined;
  /** Pour se poser dans une colonne qui etire ses enfants (`self-start`). */
  className?: string;
}): JSX.Element | null {
  const mention = mentionHorsIa(famille, useContext(OuverturesIaContext));
  if (mention === null) return null;
  return (
    <span
      title={mention.raison}
      className={`inline-flex shrink-0 items-center rounded-pill border border-border bg-surface px-2 py-0.5 text-xs font-medium leading-[1.3] text-ink-500${
        className === undefined ? '' : ` ${className}`
      }`}
    >
      {mention.libelle}
    </span>
  );
}
